<template>
  <div class="layout-template-path"
       @click="handleSwitchPath">
    <slot></slot>
  </div>
</template>

<script>
import Navigator from '../../mixins/navigator'
export default {
  name: 'TemplatePath',
  mixins: [Navigator],
  props: {
    menus: Array,
    onSuccess: Function,
    onError: Function
  },
  methods: {
    handleSwitchPath () {
      this.navigateToPath(this.menus, this.onSuccess, this.onError)
    }
  }
}
</script>

<style lang="scss">
  .layout-template-path {
    display: inline-block;
    cursor: pointer;
  }
</style>
